export default "__VITE_ASSET__48a0ab30__"